module.exports = __webpack_public_path__ + "static/media/bottom_banner_3_1.7788b9e4.png";